<div class="row">
  @for (item of summary(); track $index) {
    <div id="finance-infoData-{{$index}}" class="col-12 col-md-6 col-lg-3">
      <widget-info
        id="finance-widget-info-{{$index}}"
        [text]="item.text"
        [title]="item.title"
        [textSub]="item.overLine"
        [icon]="item.icon"
        [color]="item.color"/>
    </div>
  }
</div>
<div class="row mt-24">
  <div class="col-md-6 mt-24">
    <widget title="App Insight Requests"
            subTitle="Distribution of app insight requests in {{appInsightRequestsSubtitle()}}">
      <ng-container widgetActions>
        <button mat-menu-item (click)="toggleAppInsightRequestsPresentation(0)">
          <mat-icon>attach_money</mat-icon>
          <span>Amount</span>
        </button>
        <button mat-menu-item (click)="toggleAppInsightRequestsPresentation(1)">
          <mat-icon>percent</mat-icon>
          <span>Percentage</span>
        </button>
      </ng-container>
      <div class="widget-chart-wrap" widgetContent>
        <app-insight-requests [data]="appInsightRequestsChartData()"
                              [presentationType]="appInsightRequestsPresentation()"/>
      </div>
    </widget>
  </div>
  <div class="col-md-6 mt-24">
    <widget title="App Insight Queries" subTitle="Distribution of app insight queries in amount">
      <div class="widget-chart-wrap" widgetContent>
        <app-insight-queries [data]="appInsightQueriesChartData()"
                             [labels]="appInsightQueriesChartData().labels"
                             [presentationType]="appInsightQueriesPresentation()"/>
      </div>
    </widget>
  </div>
  <div class="row mt-24">
    <div widgetContent>
      <div>
        <app-error-logs-list/>
      </div>
    </div>
  </div>
</div>
